import { AuthRole } from '@libs/types';

export const DEFAULT_USER = {
  user: {
    firstName: '',
    lastName: '',
    email: '',
    phoneCountryCode: '+1',
    phoneNumber: '',
    role: AuthRole.JOBSEEKER,
  },
  password: '',
  confirmPassword: '',
};
